<ng-container *ngIf="render$ | async" />

<ng-container *ngIf="panel$ | async">
  <div mat-dialog-title i18n>Обработка углов</div>
  <mat-dialog-content class="flex flex-row items-stretch gap-4">
    <csl-angle-settings
      [panel]="panel"
      [anglePosition]="data.angle"
      [materialType]="panel.material.type"
      [angleProcessingAvailability]="data.angleProcessingAvailability"
      [outlineOptions]="data.outlineEditorOptions">
    </csl-angle-settings>

    <div class="basis-[350px]">
      <csl-svg-workspace #svgWorkspace [p]="panel"></csl-svg-workspace>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="accent" data-testid="saveAngleButton" (click)="save(panel)" cdkFocusInitial i18n>Сохранить</button>
    <button mat-button [mat-dialog-close] i18n>Отмена</button>
  </mat-dialog-actions>
</ng-container>
